/* The YouTube embed: 16:9, at least 200 px, always visible, never covered */
.player {
  position: relative;
  aspect-ratio: 16 / 9;
  width: 100%;
  min-height: 200px;
  background: var(--panel2);
  border: 1px solid var(--line);
  border-radius: var(--r-readout);
  overflow: hidden;
}

.host {
  position: absolute;
  inset: 0;
}

.host iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

/* Shown only while there is no player to show (loading, offline) */
.placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ink2);
}

.blocked {
  margin-top: var(--s2);
  color: var(--slate);
}

.halfDouble {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--s2);
}

.rateRow {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 52px;
  padding: 0;
  background: transparent;
  border: 0;
  border-top: 1px solid var(--line);
  color: var(--ink);
  font-size: 1rem;
  font-weight: 500;
  text-align: left;
}

.rateRow[aria-checked='true'] {
  color: var(--slate);
  font-weight: 700;
}

.source {
  display: flex;
  align-items: center;
  gap: var(--s2);
  min-width: 0;
}

.source > :first-child {
  flex: 0 0 auto;
  width: 11rem;
}

.source > button {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.feedback {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s1);
}

.title {
  margin-top: var(--s4);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.why {
  margin-top: var(--s1);
}

.controls {
  container: controls / inline-size;
  display: flex;
  flex-direction: column;
  gap: var(--s3);
  margin-top: auto;
  padding-top: var(--s5);
}

.rule {
  height: 1px;
  margin: 0 0 var(--s2);
  border: 0;
  background: var(--line);
}

.transport {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.35fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--s2);
}

.loop {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: var(--s2);
}

/* A quarter-width readout: tighter padding keeps BPM and its value on one line */
.loop .readout {
  padding: 0 var(--s2);
}

.helper {
  margin-top: calc(-1 * var(--s1));
  color: var(--ink2);
}

.last {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr) minmax(0, 1fr) 52px;
  gap: var(--s2);
}

.value {
  font-family: var(--font-mono);
  font-size: 1.25rem;
  font-weight: 400;
}

.small {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--ink2);
}

.tight {
  padding: 0 var(--s2);
}

.label {
  font-weight: 650;
}

/* Large text (e.g. 200 % text zoom): two controls per row instead of four.
   em here is the container's font size, so this only kicks in when type scales. */
@container controls (width < 22em) {
  .transport,
  .loop,
  .last {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* "Open on YouTube" after an error 100, 101 or 150 on a reopened record */
.link {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  color: var(--slate);
  text-decoration: underline;
}

/* History's filter chip row: the chip keeps its own width */
.filters {
  display: flex;
  gap: var(--s2);
  margin-top: var(--s2);
}

.sourceSheet {
  display: flex;
  flex-direction: column;
  gap: var(--s4);
}

.genres {
  margin: 0;
  padding: 0;
  border: 0;
  min-width: 0;
}

.genreChips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s2);
}

.count {
  font-family: var(--font-mono);
  color: inherit;
  opacity: 0.75;
}
